module.exports = __webpack_public_path__ + "assets/payment-method-checked.701c7671.svg";